import { initProfileReadme } from '../../../users/profile/readme/index.js?vue3';

initProfileReadme();
